export default __webpack_public_path__ + "static/media/portfolio5.566aca80.jpg";